import { render, staticRenderFns } from "./FilterCustomers.vue?vue&type=template&id=5f399d7a&lang=pug"
import script from "./FilterCustomers.vue?vue&type=script&lang=js"
export * from "./FilterCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports